<template>
    <div class="btn-toolbar" role="toolbar" aria-label="Toolbar with button groups">
        <div class="btn-group mr-2" role="group" aria-label="Apply group">
            <button type="button" class="btn btn-outline-secondary" v-on:click="RefreshData" id="apply-filters-button">
                {{ applyButtonName }}
            </button>
        </div>
        <div class="btn-group mr-2" role="group" aria-label="Cancel group">
            <button type="button" class="btn btn-outline-secondary" v-on:click="$emit('cancelSession')">
                {{ cancelButtonName }}
            </button>
        </div>
    </div>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
    data() {
        return {
            advancedQuery: { Relational: {}, MrAttributes: {} },
            dataRequestErrors: null
        };
    },
    computed: {
        ...mapState("tumourDataModule", {
            nationalData: (state) => state.nationalData,
        }),
        ...mapState("kaplanMeierModule", {
            kaplanMeierParameter: (state) => state.kaplanMeierParamete,
        }),
        ...mapState({
            patientQuery: (state) => state.patientQuery,
            caseQuery: (state) => state.caseQuery,
            advancedQueryCriteria: (state) => state.advancedQueryCriteria,
        }),
        ...mapState("contextModule", {
            context: (state) => state.context,
        }),
    },
    props: {
        applyButtonName: String,
        cancelButtonName: String,
        module: String,
    },
    methods: {
        ...mapActions([
            "tumourDataModule/setDataLoading",
            "tumourDataModule/readData",
            "tumourDataModule/readNationalData",
            "tumourDataModule/cleanData",
        ]),
        ...mapActions([
            "rhinoDataModule/setDataLoading",
            "rhinoDataModule/readData",
            "rhinoDataModule/readNationalData",
            "rhinoDataModule/cleanData",
        ]),
        ...mapActions([
            "ciDataModule/setDataLoading",
            "ciDataModule/readData",
            "ciDataModule/readNationalData",
            "ciDataModule/cleanData",
        ]),
        ...mapActions([
            "tagDataModule/setDataLoading",
            "tagDataModule/readData",
            "tagDataModule/readNationalData",
            "tagDataModule/cleanData",
        ]),
        ...mapActions([
            "patientsListDataModule/setDataLoading",
            "patientsListDataModule/readData",
            "patientsListDataModule/cleanData",
        ]),
        ...mapActions("treeListDataModule", ["readMrAttributesForTreeView", "readMrAttributesNationalDataForTreeView"]),
        ...mapActions("kaplanMeierModule", ["readKaplanMeierEstimates"]),
        RefreshData: function () {

            this[`${this.module}DataModule/setDataLoading`](true);
            this.$emit("collapse");

            var selectedContext = { id: null, type: null };

            if (this.context.id !== null && this.context.type !== null) {
                selectedContext = {
                    id: this.context.id,
                    type: this.context.type,
                };
            }

            this[`${this.module}DataModule/cleanData`]();
            this[`${this.module}DataModule/readData`](selectedContext)
                .catch((error) => {
                    this.isErrorWhileReadingDataOccurred = true;
                })
                .then((result) => {
                    this[`${this.module}DataModule/setDataLoading`](false);
                });

            if (this.module == 'patientsList')
                return;
            
            this[`${this.module}DataModule/readNationalData`](selectedContext).catch((error) => {
                this.isErrorWhileReadingDataOccurred = true;
            });

            this.readMrAttributesForTreeView(selectedContext).catch((error) => {
                this.isErrorWhileReadingDataOccurred = true;
            });

            this.readMrAttributesNationalDataForTreeView(selectedContext).catch((error) => {
                this.isErrorWhileReadingDataOccurred = true;
            });

            this.readKaplanMeierEstimates({
                context: selectedContext,
                kaplanMeierParameter: {},
            }).catch((error) => {
                this.isErrorWhileReadingDataOccurred = true;
            });
        },

        CleanData: function(){
            this[`${this.module}DataModule/cleanData`]();
        }
    },
};
</script>
